<template>
    <section class="section parallax"
             :style="style">
            <slot></slot>
        <div v-if="hasCaption" class="caption" v-text="caption"></div>
    </section>
</template>
<script>
    export default {
        props: {
            background: {
                type: String,
                required: true
            },
            caption: {
                type: String,
                required: false,
                default: null
            }
        },
        data() {
            return {
                size: null,
                ratio: null,
                bounding: null,
                x: 0,
                speed: .18,
                direction: 1,
                callback: this.animate.bind(this),
                backgroundPosition: null,
                backgroundSize: null
            }
        },
        mounted() {
            if( window.matchMedia('(max-width: 992px)').matches ) return

            this.setSize();
            document.addEventListener('scroll', this.callback)
        },
        destroyed() {
            document.removeEventListener('scroll', this.callback )
        },
        methods: {
            inViewport() {
                this.bounding = this.$el.getBoundingClientRect();

                return (
                    this.bounding.top <= window.innerHeight &&
                    this.bounding.y >= this.bounding.height * -1
                )
            },
            setSize() {
                let image = new Image();
                image.src = this.background;

                image.addEventListener('load', () => {
                    this.ratio = image.height / image.width
                    this.size =  {
                        width: this.$el.clientWidth * 1.25,
                        height: (this.$el.clientWidth * 1.25) * this.ratio
                    }
                    this.backgroundSize = this.size.width+'px '+this.size.height+'px';

                    this.setPosition();
                })
            },
            setPosition() {
                this.x = (this.$el.clientWidth / 2 - this.size.width / 2);
                this.backgroundPosition = `${this.x}px 50%`;
                this.animate()
            },
            animate() {
                if( ! this.inViewport() ) return;
                let yPos = ((this.bounding.y / this.ratio) * 100 / this.bounding.height) * this.direction * this.speed + 50;

                if( yPos > 100 ) yPos = 100;
                if( yPos < 0 ) yPos = 0;

                this.backgroundPosition = `${this.x}px ${yPos}%`;
            }
        },
        computed: {
            hasCaption() {
                return this.caption;
            },
            style() {
                if( window.matchMedia('(max-width: 992px)').matches ) {
                    return {
                        backgroundImage: 'url('+this.background+')',
                        backgroundSize: 'cover'
                    }
                }
                return {
                    backgroundImage: 'url('+this.background+')',
                    backgroundAttachment: 'fixed',
                    backgroundSize: this.backgroundSize,
                    backgroundPosition: this.backgroundPosition
                }
            }
        }
    }
</script>